/**
 * Convert a SCSS/CSS transition time string from seconds to milliseconds for use in a timeout
 *
 * @param {string} transitionStr transition time as string pulled directly from DOM CSS or as SCSS var
 */
export default function(str) {
    let ms = 0;

    const num = parseFloat(str, 10) || 0;
    let unit = str.match(/m?s/) || 's';

    if(unit) {
        unit = unit[0];
    }

    if(unit === 's') {
        ms = num * 1000;
    } else if(unit === 'ms') {
        ms = num;
    }

    return ms;
}
